var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-container",
    [
      _c(
        "b-row",
        { staticClass: "justify-content-center mt-5 mb-5" },
        [
          _c("b-img", {
            attrs: { alt: "Responsive image", fluid: "", src: "/favicon.ico" },
          }),
        ],
        1
      ),
      _c(
        "b-row",
        { staticClass: "justify-content-center" },
        [
          _c("b-card", { attrs: { title: "Accueil" } }, [
            _c("p", [
              _vm._v(
                "Bienvenue sur le site de gestion de l'association poureux"
              ),
            ]),
            _c("div"),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }